import API from '../api'
import getUrl from './paths'

export const generateReport = (organisationId, fetchData = false) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.generateReport, { organisationId, fetchData, removeDefault: true })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => reject(err))
	})

export const getPdcByOrganisation = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getPdcByOrganisation, { organisationId, removeDefault: true })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((err) => reject(err))
	})
